import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import React, { useState, useCallback, useMemo } from 'react';
import { runAll, toggleInObject } from '@elliemae/ds-utilities/utils';
import DropdownMenuContext from './DropdownMenuContext.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var noop = function noop() {
  return null;
};

function DropdownMenuProvider(_ref) {
  var _ref$onSelectMenuItem = _ref.onSelectMenuItem,
      onSelectMenuItem = _ref$onSelectMenuItem === void 0 ? noop : _ref$onSelectMenuItem,
      _ref$onOpenMenu = _ref.onOpenMenu,
      onOpenMenu = _ref$onOpenMenu === void 0 ? noop : _ref$onOpenMenu,
      onClose = _ref.onClose,
      children = _ref.children,
      isOpen = _ref.isOpen,
      selection = _ref.selection,
      singleGroupSelection = _ref.singleGroupSelection,
      _ref$onSelectChange = _ref.onSelectChange,
      onSelectChange = _ref$onSelectChange === void 0 ? noop : _ref$onSelectChange;

  var _useState = useState(isOpen),
      _useState2 = _slicedToArray(_useState, 2),
      isMenuOpen = _useState2[0],
      setMenuOpen = _useState2[1];

  var closeMenu = useCallback(function () {
    setMenuOpen(false);
    onOpenMenu(false);
    onClose();
  });
  var openMenu = useCallback(function () {
    setMenuOpen(true);
    onOpenMenu(true);
  });

  var handleItemClick = function handleItemClick(_ref2) {
    var item = _ref2.item,
        group = _ref2.group;
    var activeState; // reset selection if single selection group is activated

    var nextSelection = !singleGroupSelection ? selection : {};

    if (group) {
      activeState = group.active;
      nextSelection = _objectSpread(_objectSpread({}, nextSelection), {}, _defineProperty({}, group.id, activeState));
    } else {
      var selectionItem = group || item;
      activeState = selectionItem.active || selectionItem.checked; // can be toggled (radio with unselection)

      nextSelection = Array.isArray(activeState) ? _objectSpread(_objectSpread({}, nextSelection), {}, _defineProperty({}, selectionItem.id, activeState)) : toggleInObject(nextSelection, selectionItem.id, item.label || activeState || true);
    }

    onSelectChange({
      item: item,
      group: group,
      selection: nextSelection
    }); // todo: just pass item on item and group when selection callback,
    //  use onSelectchange for nextSelection

    onSelectMenuItem(item, activeState, nextSelection);
  };

  var handleCloseOnClick = useCallback(function (_ref3) {
    var item = _ref3.item,
        _ref3$group = _ref3.group,
        group = _ref3$group === void 0 ? {} : _ref3$group;

    if (item.closeOnClick !== undefined) {
      if (item.closeOnClick) closeMenu();
      return;
    }

    if (group.closeOnClick !== undefined) {
      if (group.closeOnClick) closeMenu();
    }
  }, []);
  var valueProvider = useMemo(function () {
    return {
      onItemClick: runAll(handleItemClick, handleCloseOnClick),
      closeMenu: closeMenu,
      openMenu: openMenu,
      isMenuOpen: isMenuOpen,
      selection: selection
    };
  }, [isMenuOpen, selection]);
  return /*#__PURE__*/React.createElement(DropdownMenuContext.Provider, {
    value: valueProvider
  }, children);
}

export default DropdownMenuProvider;
//# sourceMappingURL=DropdownMenuProvider.js.map
